module.exports = __webpack_public_path__ + "img/solution_bg1.18a05d4.jpg";